import { Fact } from '../types';

export const referencingLinkRegex = /\[(\d+)\]\{([a-f0-9-]{36})\}/g;

export const cleanReferencesAndCopyToClipboard = (content: string | undefined) => {
  if (!content) return '';
  const cleanedText = content
    .replace(referencingLinkRegex, '')
    .replace(/ +/g, ' ')
    .replace(/<b>/g, '')
    .replace(/<\/b>/g, '')
    .replace(/<br>/g, '\n');

  navigator.clipboard.writeText(cleanedText);
};

export const formatReferencesWithRefsAtEnd = (text: string, keyFacts: Fact[]) => {
  const referenceMap: Map<string, { originalNum: string; uuid: string }> = new Map();

  // First pass: collect all references
  const firstMatches = Array.from(text.matchAll(referencingLinkRegex));
  for (const match of firstMatches) {
    const [_, refNum, uuid] = match;
    if (!referenceMap.has(uuid)) {
      referenceMap.set(uuid, { originalNum: refNum, uuid });
    }
  }

  const newReferenceMap: Map<string, number> = new Map();
  const uuidOrder: string[] = [];

  // Second pass: maintain order of appearance
  const secondMatches = Array.from(text.matchAll(referencingLinkRegex));
  for (const match of secondMatches) {
    const uuid = match[2];
    if (!uuidOrder.includes(uuid)) {
      uuidOrder.push(uuid);
    }
  }

  uuidOrder.forEach((uuid, index) => {
    newReferenceMap.set(uuid, index + 1);
  });

  let newText = text.replace(referencingLinkRegex, (_, __, uuid) => {
    const newNumber = newReferenceMap.get(uuid);
    return `[${newNumber}]`;
  });

  newText += '\n\nReferences:\n';
  uuidOrder.forEach((uuid, index) => {
    const referencedFact = keyFacts.find((fact) => fact.id === uuid);

    const citations = referencedFact?.locations.map((location) => {
      const fileName = location.doc?.file.name ?? '';
      const pageNumbers = [...new Set(location.boundingBoxes.map((box) => box.pageNumber))].sort().join(', ');

      return `${fileName} (Page${pageNumbers.length > 1 ? 's' : ''} ${pageNumbers})`;
    });

    newText += `${index + 1}. ${citations?.join(', ')}\n`;
  });

  return newText;
};
